import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Governorate } from '../interfaces/governorate';

@Injectable({
  providedIn: 'root'
})
export class GovernoratesService {

  constructor(private http:HttpClient) { }

  getAllGovernorates():Observable<any>{
    return this.http.get(environment.Server_URL+'/governorates');
  }

  getCity(id:any):Observable<any>{
    return this.http.get(environment.Server_URL+`/governorates/${id}/cities`);
  }
  getGovernoratePrice(governorate_id: number): Observable<any> {
  return this.http.post(environment.Server_URL + '/governorates/price', {
    governorate_id: governorate_id
  });
}

}
